import { render, staticRenderFns } from "./Scenter.vue?vue&type=template&id=47457e1c"
import script from "./Scenter.vue?vue&type=script&lang=js"
export * from "./Scenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports